try {
  class ProductMain extends HTMLElement {
    constructor() {
      super();

      window.HS_SLIDE_CART_UPDATED = (cart) => {
        updateCartItemItemsContent(cart);
        // Runs every time the slider cart is updated.
        const giftElement = this.querySelector("[name='gifts']");
        if (giftElement == null) {
          return;
        }
        const gift = giftElement.value;
        const productId = this.querySelector("[name='id']").value;

        if (cart.items.length && gift) {
          const productItems = cart.items.filter(
            (item) => Number(item.id) === Number(productId)
          );

          let productItem = null;
          if (productItems.length > 1) {
            productItem = productItems[0];
            const qty = productItems.reduce((acc, item) => {
              item.quantity += acc;
            });
            productItem.quantity = qty;
          } else {
            productItem = productItems[0];
          }

          const giftItem = cart.items.find(
            (item) => Number(item.id) === Number(gift)
          );
          var data = [];
          //BOGO
          if (Number(productId) == Number(gift)) {
            const inputQty = this.querySelector("[name='quantity'").value;
            // subscription product
            if (typeof productItem.selling_plan_allocation !== "undefined") {
              data.push({
                id: gift,
                quantity: productItem.quantity,
                properties: {
                  _isGift: true,
                },
              });
            } else {
              if (inputQty * 2 > productItem.quantity) {
                data.push({
                  id: gift,
                  quantity: inputQty * 2 - productItem.quantity,
                  properties: {
                    _isGift: true,
                  },
                });
              }
            }
          } else {
            // free gift
            if (productItem && !giftItem) {
              const giftElement = this.querySelector("[name='gifts']");
              const gift = giftElement.value;

              data.push({
                id: gift,
                quantity: productItem.quantity,
                properties: { _isGift: true },
              });
              if (giftElement.dataset.property) {
                data[0].properties = JSON.parse(giftElement.dataset.property);
              }
            }
          }

          if (data.length) {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", "/cart/add.js", true);
            xhr.setRequestHeader(
              "Content-Type",
              "application/json; charset=UTF-8"
            );
            xhr.send(JSON.stringify({ items: data }));
          }
        }
      };
    }
  }

  customElements.define("product-main", ProductMain);
} catch (e) {}
